import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import Table from './table';

const useStyles = makeStyles((theme: { spacing: (arg0: number) => any }) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {},
  createButton: {
    paddingBottom: theme.spacing(2),
  },
}));
function Rider(props: any) {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={3} className={classes.createButton}>
        <Button variant="contained" color="primary" onClick={() => props.history.push('/dashboard/rider/create')}>
          ADD Rider
        </Button>
      </Grid>

      <Grid item xs={12} className={classes.createButton}>
        <Table />
      </Grid>
    </Grid>
  );
}

export default withRouter(Rider);
